const mapCbiEntityTableComponents = () => {
  return null;
};

export default mapCbiEntityTableComponents;
